var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "Admin" } }, [
    !_vm.ready
      ? _c("p", [_vm._v(_vm._s(_vm.$t("message.loading")))])
      : _vm._e(),
    _vm._v(" "),
    _vm.ready
      ? _c(
          "section",
          { staticStyle: { padding: "10px", "font-size": "13px" } },
          [
            _c("p", [_vm._v("Users (" + _vm._s(_vm.users.length) + ")")]),
            _vm._v(" "),
            _c("div", { staticClass: "row mb-3" }, [
              _c("div", { staticClass: "col-12" }, [
                _vm._v("\n        Sort by\n      ")
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-12" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-web btn-sm btn-sort",
                    class: [{ active: _vm.sort == "" }],
                    attrs: { type: "button" },
                    on: {
                      click: function($event) {
                        _vm.sort = ""
                      }
                    }
                  },
                  [_vm._v("\n          Latest Joined\n        ")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-web btn-sm btn-sort",
                    class: [
                      { active: _vm.sort == "?sortby_latest_active=desc" }
                    ],
                    attrs: { type: "button" },
                    on: {
                      click: function($event) {
                        _vm.sort = "?sortby_latest_active=desc"
                      }
                    }
                  },
                  [_vm._v("\n          Latest Active\n        ")]
                )
              ])
            ]),
            _vm._v(" "),
            _c("table", { staticClass: "table", attrs: { width: "100%" } }, [
              _vm._m(0),
              _vm._v(" "),
              _c(
                "tbody",
                _vm._l(_vm.users, function(user, index) {
                  return _c("tr", [
                    _c("td", [_vm._v(_vm._s(index + 1))]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(user.email || user.username))]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(user.type))]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(_vm._s(_vm.getDateTime(user.created_at)))
                    ]),
                    _vm._v(" "),
                    _c(
                      "td",
                      [
                        user.analytics.latest_active
                          ? [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.getFriendlyTime(
                                      user.analytics.latest_active
                                    )
                                  ) +
                                  "\n            "
                              )
                            ]
                          : _vm._e()
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(user.verify.email))]),
                    _vm._v(" "),
                    _c("td", [
                      user.shops.length > 0
                        ? _c(
                            "ul",
                            _vm._l(user.shops, function(shop, index_) {
                              return _c(
                                "li",
                                {
                                  staticStyle: {
                                    "border-bottom": "1px solid #000"
                                  }
                                },
                                [
                                  _c(
                                    "router-link",
                                    {
                                      attrs: {
                                        to: {
                                          name: "AdminShopInfo",
                                          query: {
                                            shop_id: shop.shop_id
                                          }
                                        }
                                      }
                                    },
                                    [
                                      _c("img", {
                                        attrs: {
                                          src:
                                            shop.logo.thumbnail ||
                                            "https://i.imgur.com/obK0kqI.png",
                                          width: "35"
                                        }
                                      }),
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(shop.shop_name) +
                                          " (" +
                                          _vm._s(shop.shop_id) +
                                          ")\n                "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("br"),
                                  _vm._v(" "),
                                  [
                                    _vm._v(
                                      "\n                  Installed:\n                  "
                                    ),
                                    _vm._l(shop.install_apps, function(
                                      permission,
                                      index__
                                    ) {
                                      return _c(
                                        "p",
                                        {
                                          staticClass: "badge badge-secondary",
                                          style:
                                            "margin: 0 5px 0 0;background:" +
                                            _vm.$t(
                                              _vm.getAppInfo(permission.app_id)
                                                .translate + ".bgcolor"
                                            )
                                        },
                                        [
                                          _c("i", {
                                            class: _vm.$t(
                                              _vm.getAppInfo(permission.app_id)
                                                .translate + ".icon"
                                            )
                                          }),
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(
                                                _vm.$t(
                                                  _vm.getAppInfo(
                                                    permission.app_id
                                                  ).translate + ".title"
                                                )
                                              ) +
                                              "\n                  "
                                          )
                                        ]
                                      )
                                    })
                                  ]
                                ],
                                2
                              )
                            }),
                            0
                          )
                        : _c("span", [
                            user.employee
                              ? _c(
                                  "span",
                                  [
                                    _c(
                                      "router-link",
                                      {
                                        attrs: {
                                          to: {
                                            name: "AdminShopInfo",
                                            query: {
                                              shop_id: user.employee.shop_id
                                            }
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(user.employee.shop_id) +
                                            "\n                "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              : _vm._e()
                          ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "td",
                      [
                        _c(
                          "router-link",
                          {
                            attrs: {
                              to: {
                                name: "AdminUserLog",
                                query: {
                                  user_id: user.user_id
                                }
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n              View Logs (" +
                                _vm._s(user.log_count) +
                                ")\n            "
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ])
                }),
                0
              )
            ])
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", { staticStyle: { "font-size": "13px" } }, [_vm._v("No.")]),
        _vm._v(" "),
        _c("th", { staticStyle: { "font-size": "13px" } }, [
          _vm._v("Email / Username")
        ]),
        _vm._v(" "),
        _c("th", { staticStyle: { "font-size": "13px" } }, [_vm._v("Type")]),
        _vm._v(" "),
        _c("th", { staticStyle: { "font-size": "13px" } }, [_vm._v("Created")]),
        _vm._v(" "),
        _c("th", { staticStyle: { "font-size": "13px" } }, [
          _vm._v("Latest Active")
        ]),
        _vm._v(" "),
        _c("th", { staticStyle: { "font-size": "13px" } }, [_vm._v("Verify")]),
        _vm._v(" "),
        _c(
          "th",
          { staticStyle: { "font-size": "13px" }, attrs: { width: "500" } },
          [_vm._v("Shops")]
        ),
        _vm._v(" "),
        _c("th", { staticStyle: { "font-size": "13px" } }, [_vm._v("Logs")])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4a38f016", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a38f016","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/UserAll.vue
// module id = null
// module chunks = 